import { useState } from 'react';
import Validator from 'validatorjs';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia/index.js';

const DeduccOSalidasForm = (props) => {
  const data = props.data;
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const handleOnChange = (event) => {
    const validator = validate({
      ...props.data,
      ...event,
    });

    props.onFormDataChange(event, {
      step: 'base',
      name: 'isValidDeduccOSalidas',
      isValid: validator.passes(),
    });
  };

  const getRules = (data) => {
    return {
      MontTotEgresPeriodo: ['required', 'decimal:6'],
      PartPropDelFideicom: ['required', 'decimal:6'],
      PropDelMontTot: ['required', 'regex:/^\\d{1,3}\\.\\d{1,6}$/'],
      ConceptoS: ['required', 'string', 'min:1', 'max:100'],
    };
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidator(newValidator);

    return validator;
  };

  const rules = getRules(data);

  return (
    <Form autoComplete="off">
      <Row>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Monto total de los egresos"
            name="MontTotEgresPeriodo"
            placeholder=""
            help=""
            rules={rules.MontTotEgresPeriodo}
            value={data.MontTotEgresPeriodo}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Parte proporcional"
            name="PartPropDelFideicom"
            placeholder=""
            help=""
            rules={rules.PartPropDelFideicom}
            value={data.PartPropDelFideicom}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Proporción del monto total"
            name="PropDelMontTot"
            placeholder=""
            help=""
            rules={rules.PropDelMontTot}
            value={data.PropDelMontTot}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={12}
        >
          <FormControl
            as="textarea"
            label="Descripción del concepto"
            name="ConceptoS"
            placeholder=""
            help=""
            minLength="1"
            maxLength="100"
            rules={rules.ConceptoS}
            value={data.ConceptoS}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default DeduccOSalidasForm;
